<template>
<div class="flex justify-end items-center relative z-30">
  <div>
    <custom-general-select :options="options" v-model="selected"
      :isLarge="false" :hasOverflow="false"
      button-bg-color="bg-white" options-bg-color="bg-white" />
  </div>
</div>
</template>

<script>
import dayjs from 'dayjs';
import { mapGetters, mapActions } from 'vuex';
import CustomGeneralSelect from './CustomGeneralSelect.vue';

export default {
  components: { CustomGeneralSelect },
  props: ['options'],

  data() {
    return {
      open: false,
      selected: '',
    };
  },

  computed: {
    ...mapGetters({
      choosenTimezone: 'timezone/choosenTimezone',
      isTeacher: 'auth/isTeacher',
    }),
  },

  created() {
    this.selected = this.choosenTimezone;
  },

  watch: {
    selected() {
      this.changeTimezone();
    },

    choosenTimezone() {
      this.selected = this.choosenTimezone;
    },
  },

  methods: {
    ...mapActions({
      setChoosenTimezone: 'timezone/setChoosenTimezone',
    }),

    changeTimezone() {
      this.setChoosenTimezone(this.selected);
      dayjs.tz.setDefault(this.selected);
    },
  },
};
</script>
